document.addEventListener("DOMContentLoaded", () => {
    const submenuToggles = document.querySelectorAll(".submenu-toggle");

    submenuToggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
            e.preventDefault();
            const parent = toggle.closest(".has-submenu");
            parent.classList.toggle("active");
        });
    });
});
